"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _excluded = ["title", "titleId"];
var SvgLeaf = function SvgLeaf(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.844 1.137a1.502 1.502 0 0 0-.451.06C8.76 1.677 4.575 3.058 2.66 5.91l-.008.011-.006.011c-.547.914-.625 1.78-.625 2.468 0 1.279.605 2.362 1.392 3.114.492.471 1.054.768 1.624.968a8.097 8.097 0 0 1-2.355 1.208.5.5 0 1 0 .303.953c3.883-1.235 6.295-4.887 7.091-8.653a.5.5 0 0 0-.978-.207c-.47 2.22-1.544 4.362-3.146 5.914-.52-.035-1.256-.34-1.848-.906-.628-.6-1.083-1.428-1.083-2.39 0-.62.054-1.23.479-1.945 1.613-2.387 5.623-3.843 7.175-4.3.203-.059.418.01.544.177 1.473 1.935 2.093 4.412 2.114 5.944.021 1.62-.39 2.826-1.026 3.628-.635.8-1.492 1.22-2.487 1.26-.498 0-1.099.012-1.85-.562a.5.5 0 1 0-.607.794c.99.756 1.97.77 2.47.77h.01l.01-.001a4.298 4.298 0 0 0 3.238-1.64c.808-1.02 1.265-2.466 1.241-4.262-.024-1.776-.681-4.388-2.317-6.537a1.506 1.506 0 0 0-1.171-.59Z"
  }));
};
var _default = SvgLeaf;
exports.default = _default;